import React, { useEffect, useState } from "react";
import {
  Form,
  Row,
  Col,
  Button,
  Card,
  Modal,
  FloatingLabel,
  ProgressBar,
  CardBody,
} from "react-bootstrap";

import axios from "axios";
import Swal from "sweetalert2";
import { Link, useNavigate } from "react-router-dom";
import PageLayout from "../../../layouts/PageLayout";
import GalleryUpload from "./GalleryUpload";
import Select from "react-select";

export default function AddMedicalCare() {
  const navigate = useNavigate();

  // ================================================================
  // INITIAL DATA
  // ================================================================

  const [families, setFamilies] = useState([]);
  const [people, setPeople] = useState([]);
  const [hospitals, setHospitals] = useState([]);
  const [cities, setCities] = useState([]);

  const [loadingFamilies, setLoadingFamilies] = useState(false);
  const [loadingPeople, setLoadingPeople] = useState(false);
  const [medicines, setMedicines] = useState([]);
  const [selectedMedicines, setSelectedMedicines] = useState([]);
  // ================================================================
  // FORM
  // ================================================================

  const [values, setValues] = useState({
    person_id: "",
    patient_id: "",
    patient_name: "",
    relation: "",

    doctor_name: "",
    hospital_id: "",
    treatment_way: "",
    medicine_amount: "",
    medicine_receipt: null,

    doctor_fee: "",
    doctor_fee_receipt: null,

    medical_reason: "",
    date_of_treatment: ""
  });

  const [formErrors, setFormErrors] = useState({});

  const [submitting, setSubmitting] = useState(false);

  // ================================================================
  // HOSPITAL MODAL
  // ================================================================

  const [showHospitalModal, setShowHospitalModal] =
    useState(false);

  const [newHospital, setNewHospital] = useState({
    name: "",
    city_id: "",
    address: "",
    contact_number: "",
  });

  const [savingHospital, setSavingHospital] =
    useState(false);
  // ================================================================
  // MEDICINE MODAL
  // ================================================================

  const [showMedicineModal, setShowMedicineModal] =
    useState(false);

  const [newMedicineName, setNewMedicineName] =
    useState("");

  const [savingMedicine, setSavingMedicine] =
    useState(false);


  const openMedicineModal = () => {
    setNewMedicineName("");
    setShowMedicineModal(true);
  };
  // ================================================================
  // GALLERY
  // ================================================================

  const [medicalCareId, setMedicalCareId] =
    useState(null);

  const [images, setImages] = useState([]);

  // ================================================================
  // VIDEO
  // ================================================================

  const [selectedVideo, setSelectedVideo] =
    useState(null);

  const [uploadProgress, setUploadProgress] =
    useState(0);

  const [videoUploading, setVideoUploading] =
    useState(false);

  const [video, setVideo] = useState(null);

  // ================================================================
  // AUTH
  // ================================================================

  const AuthToken =
    localStorage.getItem("AuthUser");

  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${AuthToken}`;

  // ================================================================
  // INITIAL LOAD
  // ================================================================
  const handleMedicineChange = (selected) => {
    const selectedList = selected || [];

    setSelectedMedicines((prev) => {
      return selectedList.map((medicine) => {
        const existing = prev.find(
          (item) => item.medicine_id === medicine.value
        );

        return {
          medicine_id: medicine.value,
          medicine_name: medicine.label,
          quantity: existing ? existing.quantity : "",
        };
      });
    });
  };

  const handleMedicineQuantityChange = (medicineId, quantity) => {
    setSelectedMedicines((prev) =>
      prev.map((medicine) =>
        medicine.medicine_id === medicineId
          ? {
            ...medicine,
            quantity: quantity,
          }
          : medicine
      )
    );
  };
  useEffect(() => {
    fetchInitialData();
  }, []);

  // ================================================================
  // FETCH INITIAL DATA
  // ================================================================

  const fetchInitialData = async () => {
    setLoadingFamilies(true);

    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/initial-medical-care-data`
      );


      setMedicines(res.data.medicines || []);
      setFamilies(
        res.data.people
      );

      setHospitals(
        res.data.hospitals || []
      );

      setCities(
        res.data.cities || []
      );
    } catch (error) {
      console.error(
        "Initial Data Error:",
        error
      );

      Swal.fire({
        title: "Error!",
        text:
          error?.response?.data?.message ||
          "Failed to load medical care data.",
        icon: "error",
      });
    } finally {
      setLoadingFamilies(false);
    }
  };

  // ================================================================
  // FAMILY CHANGE
  // ================================================================
  const handlePatientChange = (e) => {
    const id = e.target.value;
    const selected = people.find((c) => c.id == id);

    setValues({
      ...values,
      patient_id: selected?.id || "",
      patient_name: selected?.name || "",
      relation: selected?.relation || "",
    });
  };

  const handleFamilyChange = async (e) => {
    const familyId = e.target.value;

    setValues((prev) => ({
      ...prev,
      person_id: familyId,
      patient_id: "",
      patient_name: "",
      relation: "",
    }));

    setPeople([]);

    setFormErrors((prev) => ({
      ...prev,
      person_id: "",
      patient_id: "",
    }));

    if (!familyId) {
      return;
    }

    setLoadingPeople(true);

    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/initial-medical-care-data/${familyId}`
      );

      console.log(
        "Family People:",
        res.data
      );

      setPeople(
        res.data.family ||
        []
      );
    } catch (error) {
      console.error(
        "Family People Error:",
        error
      );

      Swal.fire({
        title: "Error!",
        text:
          error?.response?.data?.message ||
          "Failed to load family members.",
        icon: "error",
      });
    } finally {
      setLoadingPeople(false);
    }
  };

  // ================================================================
  // GENERAL FORM CHANGE
  // ================================================================

  const handleChange = (e) => {
    const {
      name,
      value,
      type,
      files,
    } = e.target;

    if (type === "file") {
      setValues((prev) => ({
        ...prev,
        [name]: files?.[0] || null,
      }));
    } else {
      setValues((prev) => ({
        ...prev,
        [name]: value,
      }));
    }

    setFormErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  // ================================================================
  // ADD HOSPITAL MODAL OPEN
  // ================================================================

  const openHospitalModal = () => {
    setNewHospital((prev) => ({
      ...prev,
      city_id: "",
    }));

    setShowHospitalModal(true);
  };

  // ================================================================
  // SAVE HOSPITAL
  // ================================================================

  const saveHospital = async () => {
    if (!newHospital.name.trim()) {
      Swal.fire({
        title: "Error!",
        text: "Hospital name is required.",
        icon: "error",
      });

      return;
    }

    if (!newHospital.city_id) {
      Swal.fire({
        title: "Error!",
        text: "Please select city.",
        icon: "error",
      });

      return;
    }

    if (!newHospital.address.trim()) {
      Swal.fire({
        title: "Error!",
        text: "Hospital address is required.",
        icon: "error",
      });

      return;
    }

    if (!newHospital.contact_number.trim()) {
      Swal.fire({
        title: "Error!",
        text: "Contact number is required.",
        icon: "error",
      });

      return;
    }

    setSavingHospital(true);

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/store-medical-hospitals`,
        newHospital
      );

      console.log(
        "Created Hospital:",
        res.data
      );

      const created = res.data.data;

      setHospitals((prev) => [
        ...prev,
        created,
      ]);

      // Automatically select new hospital
      setValues((prev) => ({
        ...prev,
        hospital_id: created.id,
      }));

      setFormErrors((prev) => ({
        ...prev,
        hospital_id: "",
      }));

      setNewHospital({
        name: "",
        city_id: "",
        address: "",
        contact_number: "",
      });

      setShowHospitalModal(false);

      Swal.fire({
        title: "Success!",
        text: "Hospital added successfully.",
        icon: "success",
        timer: 2000,
        showConfirmButton: false,
      });
    } catch (error) {
      console.error(
        "Save Hospital Error:",
        error
      );

      Swal.fire({
        title: "Error!",
        text:
          error?.response?.data?.message ||
          "Failed to add hospital.",
        icon: "error",
      });
    } finally {
      setSavingHospital(false);
    }
  };

  // ================================================================
  // VALIDATION
  // ================================================================

  const validate = () => {
    const errors = {};

    if (!values.person_id) {
      errors.person_id =
        "Family is required";
    }

    if (!values.patient_id) {
      errors.patient_id =
        "Person is required";
    }
    if (!values.date_of_treatment) {
      errors.date_of_treatment =
        "Date of treatment is required";
    }

    if (values.treatment_way == 1) {
      if (selectedMedicines.length === 0) {
        errors.medicines =
          "Please select at least one medicine.";
      }

      selectedMedicines.forEach((medicine, index) => {
        if (
          medicine.quantity === "" ||
          Number(medicine.quantity) <= 0
        ) {
          errors[`medicine_quantity_${medicine.medicine_id}`] =
            `Please enter quantity for ${medicine.medicine_name}`;
        }
      });
    }
    if (values.treatment_way == 2) {
      if (!values.doctor_name.trim()) {
        errors.doctor_name =
          "Doctor name is required";
      }

      if (!values.hospital_id) {
        errors.hospital_id =
          "Hospital is required";
      }

      if (
        values.medicine_amount === "" ||
        values.medicine_amount === null
      ) {
        errors.medicine_amount =
          "Medicine amount is required";
      }

      if (
        Number(values.medicine_amount) > 0 &&
        !values.medicine_receipt
      ) {
        errors.medicine_receipt =
          "Medicine receipt is required when medicine amount is greater than 0.";
      }

      if (
        values.doctor_fee === "" ||
        values.doctor_fee === null
      ) {
        errors.doctor_fee =
          "Doctor fee is required";
      }

      if (
        Number(values.doctor_fee) > 0 &&
        !values.doctor_fee_receipt
      ) {
        errors.doctor_fee_receipt =
          "Doctor fee receipt is required when doctor fee is greater than 0.";
      }
    }
    if (!values.medical_reason.trim()) {
      errors.medical_reason =
        "Medical reason is required";
    }

    setFormErrors(errors);

    return (
      Object.keys(errors).length === 0
    );
  };

  // ================================================================
  // SUBMIT MEDICAL CARE
  // ================================================================

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) {
      Swal.fire({
        title: "Error!",
        text: "Please fix the errors in the form.",
        icon: "error",
      });

      return;
    }

    setSubmitting(true);

    try {
      const data = new FormData();

      data.append(
        "treatment_way",
        values.treatment_way
      );
      data.append(
        "person_id",
        values.person_id
      );

      data.append(
        "patient_name",
        values.patient_name
      );

      data.append(
        "relation",
        values.relation
      );

      data.append(
        "doctor_name",
        values.doctor_name
      );

      data.append(
        "hospital_id",
        values.hospital_id
      );

      data.append(
        "medicine_amount",
        values.medicine_amount
      );

      if (values.medicine_receipt) {
        data.append(
          "medicine_receipt",
          values.medicine_receipt
        );
      }

      data.append(
        "doctor_fee",
        values.doctor_fee
      );

      if (values.doctor_fee_receipt) {
        data.append(
          "doctor_fee_receipt",
          values.doctor_fee_receipt
        );
      }

      data.append(
        "medical_reason",
        values.medical_reason
      );
      if (values.treatment_way == 1) {
        data.append(
          "medicines",
          JSON.stringify(selectedMedicines)
        );
      }
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/medical-care`,
        data,
        {
          headers: {
            "Content-Type":
              "multipart/form-data",
          },
        }
      );

      console.log(
        "Medical Care Created:",
        res.data
      );

      const created =
        res.data.data ||
        res.data.medical_care ||
        res.data;

      if (created?.id) {
        setMedicalCareId(created.id);
      }

      Swal.fire({
        title: "Success!",
        text: "Medical care added successfully.",
        icon: "success",
        confirmButtonText: "OK",
      });

      // If API returns an ID, stay on page
      // so gallery/video can be uploaded.
      if (created?.id) {
        setMedicalCareId(created.id);

        if (created.gallery) {
          setImages(created.gallery);
        }

        if (created.video_link) {
          setVideo(created.video_link);
        }
      } else {
        // navigate("/all-medical-care");
      }
    } catch (error) {
      console.error(
        "Medical Care Error:",
        error
      );

      console.error(
        "Response:",
        error?.response?.data
      );

      Swal.fire({
        title: "Error!",
        text:
          error?.response?.data?.message ||
          "Failed to save medical care.",
        icon: "error",
      });
    } finally {
      setSubmitting(false);
    }
  };

  // ================================================================
  // VIDEO SELECT
  // ================================================================

  const handleVideoChange = (e) => {
    const file = e.target.files?.[0];

    if (!file) {
      setSelectedVideo(null);
      return;
    }

    setSelectedVideo(file);
    setUploadProgress(0);
  };

  // ================================================================
  // CHUNKED VIDEO UPLOAD
  // ================================================================

  const CHUNK_SIZE =
    5 * 1024 * 1024;

  const uploadVideoInChunks = async () => {
    if (!selectedVideo) {
      Swal.fire({
        title: "Error!",
        text: "Please select a video.",
        icon: "error",
      });

      return;
    }

    if (!medicalCareId) {
      Swal.fire({
        title: "Error!",
        text:
          "Please save the medical care form first.",
        icon: "error",
      });

      return;
    }

    setVideoUploading(true);
    setUploadProgress(0);

    try {
      const totalChunks = Math.ceil(
        selectedVideo.size /
        CHUNK_SIZE
      );

      for (
        let chunkIndex = 0;
        chunkIndex < totalChunks;
        chunkIndex++
      ) {
        const start =
          chunkIndex *
          CHUNK_SIZE;

        const end = Math.min(
          selectedVideo.size,
          start + CHUNK_SIZE
        );

        const chunk =
          selectedVideo.slice(
            start,
            end
          );

        const fd =
          new FormData();

        fd.append(
          "medical_care_id",
          String(medicalCareId)
        );

        fd.append(
          "chunk_index",
          String(chunkIndex)
        );

        fd.append(
          "total_chunks",
          String(totalChunks)
        );

        fd.append(
          "file_name",
          selectedVideo.name
        );

        fd.append(
          "video_chunk",
          chunk,
          `${chunkIndex}_${selectedVideo.name}`
        );

        const response =
          await axios.post(
            `${process.env.REACT_APP_API_URL}/medical-care-video-upload`,
            fd,
            {
              headers: {
                "Content-Type":
                  "multipart/form-data",
              },
            }
          );

        console.log(
          "Video Chunk Response:",
          response.data
        );

        const progress =
          Math.round(
            ((chunkIndex + 1) /
              totalChunks) *
            100
          );

        setUploadProgress(
          progress
        );

        // 1 second delay
        await new Promise(
          (resolve) =>
            setTimeout(
              resolve,
              1000
            )
        );
      }

      Swal.fire({
        title: "Success!",
        text:
          "Medical care video uploaded successfully.",
        icon: "success",
        confirmButtonText: "OK",
      });

      window.location.reload();
      setSelectedVideo(null);
      setUploadProgress(0);

      // Refresh video if your API supports it
      await refreshMedicalCare();
    } catch (error) {
      console.error(
        "Video Upload Error:",
        error
      );

      console.error(
        "Response:",
        error?.response?.data
      );

      Swal.fire({
        title: "Error!",
        text:
          error?.response?.data?.message ||
          "Video upload failed.",
        icon: "error",
      });
    } finally {
      setVideoUploading(false);
    }
  };

  // ================================================================
  // REFRESH MEDICAL CARE
  // ================================================================

  const refreshMedicalCare = async () => {
    if (!medicalCareId) {
      return;
    }

    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/medical-care/${medicalCareId}`
      );

      const data =
        res.data.data ||
        res.data;

      if (data.video_link) {
        setVideo(
          data.video_link
        );
      }

      if (data.images) {
        setImages(data.images);
      }
    } catch (error) {
      console.error(
        "Refresh Error:",
        error
      );
    }
  };

  // ================================================================
  // RENDER
  // ================================================================
  const familyOptions = families.map((f) => ({
    value: f.person_id,
    label: `${f.f_number} - ${f.beneficiary_name} (${f.city_name})`,
  }));

  const medicineOptions = medicines.map((medicine) => ({
    value: medicine.id,
    label: medicine.name,
  }));


  const saveMedicine = async () => {
    if (!newMedicineName.trim()) {
      Swal.fire({
        title: "Error!",
        text: "Medicine name is required.",
        icon: "error",
      });

      return;
    }

    setSavingMedicine(true);

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/medicine-save`,
        {
          name: newMedicineName,
        }
      );

      const created = res.data.data


      // Add medicine to medicine list
      setMedicines((prev) => [
        ...prev,
        created,
      ]);

      // Automatically select new medicine
      setSelectedMedicines((prev) => [
        ...prev,
        {
          medicine_id: created.id,
          medicine_name:
            created.name ||
            created.medicine_name,
          quantity: "",
        },
      ]);

      setNewMedicineName("");
      setShowMedicineModal(false);

      Swal.fire({
        title: "Success!",
        text: "Medicine added successfully.",
        icon: "success",
        timer: 2000,
        showConfirmButton: false,
      });
    } catch (error) {
      console.error(
        "Save Medicine Error:",
        error
      );

      Swal.fire({
        title: "Error!",
        text:
          error?.response?.data?.message ||
          "Failed to add medicine.",
        icon: "error",
      });
    } finally {
      setSavingMedicine(false);
    }
  };
  return (
    <PageLayout>
      {/* ==========================================================
          BREADCRUMB
      ========================================================== */}
      {!medicalCareId && (<>
        <Row>
          <Col xl={12}>
            <div className="mc-card">
              <div className="mc-breadcrumb">
                <h3 className="mc-breadcrumb-title">
                  Add New Medical Care
                </h3>

                <ul className="mc-breadcrumb-list">
                  <li className="mc-breadcrumb-item">
                    <Link
                      to="/"
                      className="mc-breadcrumb-link"
                    >
                      Home
                    </Link>
                  </li>

                  <li className="mc-breadcrumb-item">
                    <Link
                      to="/all-medical-care"
                      className="mc-breadcrumb-link"
                    >
                      Medical Care
                    </Link>
                  </li>

                  <li className="mc-breadcrumb-item">
                    Add New Medical Care
                  </li>
                </ul>
              </div>
            </div>
          </Col>
        </Row>

        {/* ==========================================================
          MAIN FORM
      ========================================================== */}

        <Card className="mt-3">
          <Card.Header>
            <h5 className="mb-0">
              Medical Care Form
            </h5>
          </Card.Header>

          <Card.Body>
            <Form onSubmit={handleSubmit}>
              <Row>
                {/* ==================================================
                  FAMILY
              ================================================== */}
                {/* Family */}
                <Col md={4}>
                  <Form.Group>
                    <Form.Label>Family</Form.Label>
                    <Select
                      classNamePrefix="custom-select"
                      options={familyOptions}
                      placeholder="Select Family"
                      isSearchable
                      value={familyOptions.find(
                        (option) => option.value === values.person_id
                      )}
                      onChange={(selected) => {
                        handleFamilyChange({
                          target: {
                            name: "person_id",
                            value: selected ? selected.value : "",
                          },
                        });
                      }}
                    />
                    <Form.Control.Feedback type="invalid">
                      {formErrors.person_id}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>

                {/* ==================================================
                  PERSON
              ================================================== */}

                <Col md={4}>
                  <Form.Group>
                    <Form.Label>Patient</Form.Label>
                    <Form.Select
                      value={values.patient_id}
                      onChange={handlePatientChange}
                      isInvalid={!!formErrors.patient_id}
                    >
                      <option value="">Select</option>
                      {people.map((c) => (
                        <option key={c.id} value={c.id}>
                          {c.name} ({c.relation})
                        </option>
                      ))}
                    </Form.Select>
                    <Form.Control.Feedback type="invalid">
                      {formErrors.patient_id}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group>
                    <Form.Label>Date</Form.Label>

                    <Form.Control
                      type="date"
                      name="date_of_treatment"
                      value={values.date_of_treatment}
                      onChange={handleChange}
                      isInvalid={!!formErrors.date_of_treatment}
                    />

                    <Form.Control.Feedback type="invalid">
                      {formErrors.date_of_treatment}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                {/* ==================================================
                  MEDICAL REASON
              ================================================== */}

                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label >Medical Reason </Form.Label>
                    <Form.Control
                      as="textarea"
                      name="medical_reason"
                      value={
                        values.medical_reason
                      }
                      onChange={
                        handleChange
                      }
                      isInvalid={
                        !!formErrors.medical_reason
                      }
                      placeholder="Medical Reason"
                      style={{
                        height: "45px",
                      }}
                    />

                    <Form.Control.Feedback type="invalid">
                      {
                        formErrors.medical_reason
                      }
                    </Form.Control.Feedback>

                  </Form.Group>
                </Col>

                {/* ==================================================
                  DOCTOR
              ================================================== */}
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Where was the patient treated?</Form.Label>
                    <Form.Select
                      name="treatment_way"
                      value={
                        values.treatment_way
                      }
                      onChange={(
                        e
                      ) => {
                        const value =
                          e.target.value;

                        setValues(
                          (
                            prev
                          ) => ({
                            ...prev,
                            treatment_way:
                              value,
                          })
                        );

                        setFormErrors(
                          (
                            prev
                          ) => ({
                            ...prev,
                            treatment_way:
                              "",
                          })
                        );
                      }}
                      isInvalid={
                        !!formErrors.treatment_way
                      }
                    >
                      <option value="">
                        Select...
                      </option>
                      <option value={1}>Mobile Health Van </option>
                      <option value={2}>Referred to Hospital</option>
                    </Form.Select>

                    <Form.Control.Feedback type="invalid">
                      {
                        formErrors.treatment_way
                      }
                    </Form.Control.Feedback>

                  </Form.Group>
                </Col>
                {/* ==================================================
                  DOCTOR
              ================================================== */}

                {values.treatment_way == 2 && (<>
                  <Col md={4}>
                    <Form.Group className="mb-3">
                      <Form.Label>Hospital</Form.Label>
                      <Form.Select
                        name="hospital_id"
                        value={
                          values.hospital_id
                        }
                        onChange={(
                          e
                        ) => {
                          const value =
                            e.target.value;

                          if (
                            value ===
                            "__add_new__"
                          ) {
                            openHospitalModal();
                            return;
                          }

                          setValues(
                            (
                              prev
                            ) => ({
                              ...prev,
                              hospital_id:
                                value,
                            })
                          );

                          setFormErrors(
                            (
                              prev
                            ) => ({
                              ...prev,
                              hospital_id:
                                "",
                            })
                          );
                        }}
                        isInvalid={
                          !!formErrors.hospital_id
                        }
                      >
                        <option value="">
                          Select Hospital
                        </option>

                        {hospitals.map(
                          (hospital) => (
                            <option
                              key={
                                hospital.id
                              }
                              value={
                                hospital.id
                              }
                            >
                              {hospital.name ||
                                hospital.hospital_name}
                            </option>
                          )
                        )}

                        <option value="__add_new__">
                          + Add New Hospital
                        </option>
                      </Form.Select>

                      <Form.Control.Feedback type="invalid">
                        {
                          formErrors.hospital_id
                        }
                      </Form.Control.Feedback>

                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group className="mb-3">
                      <Form.Label>Doctor Name</Form.Label>
                      <Form.Control
                        type="text"
                        name="doctor_name"
                        value={
                          values.doctor_name
                        }
                        onChange={
                          handleChange
                        }
                        isInvalid={
                          !!formErrors.doctor_name
                        }
                        placeholder="Doctor's Name"
                      />

                      <Form.Control.Feedback type="invalid">
                        {
                          formErrors.doctor_name
                        }
                      </Form.Control.Feedback>

                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group className="mb-3">
                      <Form.Label> Hospital Bill amount</Form.Label>
                      <Form.Control
                        type="number"
                        min="0"
                        name="doctor_fee"
                        value={
                          values.doctor_fee
                        }
                        onChange={
                          handleChange
                        }
                        isInvalid={
                          !!formErrors.doctor_fee
                        }
                        placeholder="Enter amount"
                      />

                      <Form.Control.Feedback type="invalid">
                        {
                          formErrors.doctor_fee
                        }
                      </Form.Control.Feedback>

                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Hospital Bill Receipt
                        {Number(
                          values.doctor_fee
                        ) > 0 && (
                            <span className="text-danger">
                              {" "}
                              *
                            </span>
                          )}
                      </Form.Label>

                      <Form.Control
                        type="file"
                        name="doctor_fee_receipt"
                        accept="image/*,.pdf"
                        onChange={
                          handleChange
                        }
                        isInvalid={
                          !!formErrors.doctor_fee_receipt
                        }
                      />

                      <Form.Control.Feedback type="invalid">
                        {
                          formErrors.doctor_fee_receipt
                        }
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group className="mb-3">
                      <Form.Label>Medicine Bill Amount</Form.Label>
                      <Form.Control
                        type="number"
                        min="0"
                        name="medicine_amount"
                        value={
                          values.medicine_amount
                        }
                        onChange={
                          handleChange
                        }
                        isInvalid={
                          !!formErrors.medicine_amount
                        }
                        placeholder="Enter amount"
                      />

                      <Form.Control.Feedback type="invalid">
                        {
                          formErrors.medicine_amount
                        }
                      </Form.Control.Feedback>

                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Medicine Bill Receipt
                        {Number(
                          values.medicine_amount
                        ) > 0 && (
                            <span className="text-danger">
                              {" "}
                              *
                            </span>
                          )}
                      </Form.Label>

                      <Form.Control
                        type="file"
                        name="medicine_receipt"
                        accept="image/*,.pdf"
                        onChange={
                          handleChange
                        }
                        isInvalid={
                          !!formErrors.medicine_receipt
                        }
                      />

                      <Form.Control.Feedback type="invalid">
                        {
                          formErrors.medicine_receipt
                        }
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </>)}


                {values.treatment_way == 1 && (
                  <Col md={12}>
                    <Card className="border">
                      <Card.Body>

                        <div className="d-flex justify-content-between align-items-center mb-3">
                          <h5 className="mb-0">
                            Medicines Provided to Patient
                          </h5>

                          <Button
                            variant="primary"
                            size="sm"
                            onClick={openMedicineModal}
                          >
                            + Add New Medicine
                          </Button>
                        </div>

                        <Form.Group className="mb-4">
                          <Form.Label>
                            Select Medicines
                          </Form.Label>

                          <Select
                            isMulti
                            isSearchable
                            options={medicineOptions}
                            placeholder="Search and select medicines..."
                            value={selectedMedicines.map((item) => ({
                              value: item.medicine_id,
                              label: item.medicine_name,
                            }))}
                            onChange={handleMedicineChange}
                          />

                          {formErrors.medicines && (
                            <div className="text-danger mt-1">
                              {formErrors.medicines}
                            </div>
                          )}
                        </Form.Group>

                        {selectedMedicines.length > 0 && (
                          <Row>
                            {selectedMedicines.map((medicine) => (
                              <Col
                                md={6}
                                key={medicine.medicine_id}
                              >
                                <Card className="mb-3 border">
                                  <Card.Body>
                                    <Form.Label className="fw-bold">
                                      {medicine.medicine_name}
                                    </Form.Label>

                                    <Form.Group>
                                      <Form.Label>
                                        Quantity Provided
                                      </Form.Label>

                                      <Form.Control
                                        type="text"

                                        placeholder="Enter quantity"
                                        value={medicine.quantity}
                                        onChange={(e) =>
                                          handleMedicineQuantityChange(
                                            medicine.medicine_id,
                                            e.target.value
                                          )
                                        }
                                        isInvalid={
                                          !!formErrors[
                                          `medicine_quantity_${medicine.medicine_id}`
                                          ]
                                        }
                                      />

                                      <Form.Control.Feedback type="invalid">
                                        {
                                          formErrors[
                                          `medicine_quantity_${medicine.medicine_id}`
                                          ]
                                        }
                                      </Form.Control.Feedback>
                                    </Form.Group>
                                  </Card.Body>
                                </Card>
                              </Col>
                            ))}
                          </Row>
                        )}

                      </Card.Body>
                    </Card>
                  </Col>
                )}
              </Row>

              {/* ==================================================
                SUBMIT
            ================================================== */}

              <Button
                className="py-2 px-4 mt-2"
                variant="success"
                type="submit"
                disabled={submitting}
              >
                {submitting
                  ? "Saving..."
                  : "Submit Medical Care"}
              </Button>
            </Form>

            {/* ========================================================
              GALLERY
          ======================================================== */}

            {medicalCareId && (
              <>
                <div className="mt-5 mb-3">
                  <Card.Header>
                    <h5 className="text-center mb-0">
                      Upload Picture Gallery
                    </h5>
                  </Card.Header>
                </div>

                <GalleryUpload
                  trId={medicalCareId}
                  images={images}
                />
              </>
            )}
          </Card.Body>
        </Card>


      </>

      )}

      {/* ============================================================
          VIDEO
      ============================================================ */}


      {medicalCareId && (
        <Card>
          <Card.Body>
            <Card.Header className="m-3">
              <h5 className="text-center mb-3">
                Upload Picture Gallery
              </h5>
            </Card.Header>

            <GalleryUpload
              medicalCareId={
                medicalCareId
              }
              images={[]}
            />
          </Card.Body>
        </Card >
      )}


      {medicalCareId && (
        <Row>
          {/* ========================================================
              VIDEO UPLOAD
          ======================================================== */}

          <Col md={4}>
            <Card className="mt-4">
              <Card.Body>
                <Card.Header className="mb-3">
                  <h5 className="mb-0">
                    Upload Medical Care Video
                  </h5>
                </Card.Header>

                <Form.Group>
                  <Form.Label>
                    Select Video
                  </Form.Label>

                  <Form.Control
                    type="file"
                    accept="video/*"
                    onChange={
                      handleVideoChange
                    }
                  />
                </Form.Group>

                {selectedVideo && (
                  <div className="mt-2">
                    <small className="text-muted">
                      {selectedVideo.name}
                    </small>
                  </div>
                )}

                {uploadProgress > 0 && (
                  <div className="mt-3">
                    <ProgressBar
                      now={
                        uploadProgress
                      }
                      label={`${uploadProgress}%`}
                    />
                  </div>
                )}

                <Button
                  className="mt-3"
                  disabled={
                    !selectedVideo ||
                    videoUploading
                  }
                  onClick={
                    uploadVideoInChunks
                  }
                >
                  {videoUploading
                    ? "Uploading..."
                    : "Upload Video"}
                </Button>
              </Card.Body>
            </Card>
          </Col>

          {/* ========================================================
              EXISTING VIDEO
          ======================================================== */}

          <Col md={8}>
            <Card className="mt-4">
              <Card.Body>
                {video ? (
                  <>
                    <h5 className="mb-3">
                      Current Video
                    </h5>

                    <video
                      width="100%"
                      controls
                      style={{
                        maxHeight:
                          "450px",
                        background:
                          "#000",
                        borderRadius:
                          "8px",
                      }}
                    >
                      <source
                        src={`${process.env.REACT_APP_IMG_URL}${video}`}
                        type="video/mp4"
                      />

                      Your browser does not
                      support the video tag.
                    </video>
                  </>
                ) : (
                  <div className="text-center p-5">
                    <p className="mb-0 text-muted">
                      No video uploaded yet.
                    </p>
                  </div>
                )}
              </Card.Body>
            </Card>
          </Col>
        </Row>
      )
      }

      {/* ============================================================
          ADD HOSPITAL MODAL
      ============================================================ */}

      <Modal

        show={showHospitalModal}
        onHide={() =>
          setShowHospitalModal(false)
        }
        centered
      >
        <Modal.Header className="m-3" closeButton>
          <Modal.Title>
            Add Hospital
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className="hospital-modal">
          {/* Hospital Name */}

          <Form.Group className="mb-3">
            <Form.Label>
              Hospital Name
            </Form.Label>

            <Form.Control
              type="text"
              placeholder="Enter hospital name"
              value={
                newHospital.name
              }
              onChange={(e) =>
                setNewHospital(
                  (prev) => ({
                    ...prev,
                    name: e.target.value,
                  })
                )
              }
            />
          </Form.Group>

          {/* City */}

          <Form.Group className="mb-3">
            <Form.Label>
              City
            </Form.Label>

            <Form.Select
              value={
                newHospital.city_id
              }
              onChange={(e) =>
                setNewHospital(
                  (prev) => ({
                    ...prev,
                    city_id:
                      e.target.value,
                  })
                )
              }
            >
              <option value="">
                Select City
              </option>

              {cities.map(
                (city) => (
                  <option
                    key={city.id}
                    value={city.id}
                  >
                    {city.name}
                  </option>
                )
              )}
            </Form.Select>
          </Form.Group>

          {/* Address */}

          <Form.Group className="mb-3">
            <Form.Label>
              Address
            </Form.Label>

            <Form.Control
              as="textarea"
              rows={3}
              placeholder="Enter hospital address"
              value={
                newHospital.address
              }
              onChange={(e) =>
                setNewHospital(
                  (prev) => ({
                    ...prev,
                    address:
                      e.target.value,
                  })
                )
              }
            />
          </Form.Group>

          {/* Contact */}

          <Form.Group className="mb-3">
            <Form.Label>
              Contact Number
            </Form.Label>

            <Form.Control
              type="text"
              placeholder="Enter contact number"
              value={
                newHospital.contact_number
              }
              onChange={(e) =>
                setNewHospital(
                  (prev) => ({
                    ...prev,
                    contact_number:
                      e.target.value,
                  })
                )
              }
            />
          </Form.Group>
        </Modal.Body>

        <Modal.Footer className="m-3">
          <Button
            variant="secondary"
            onClick={() =>
              setShowHospitalModal(
                false
              )
            }
            disabled={
              savingHospital
            }
          >
            Close
          </Button>

          <Button
            variant="primary"
            onClick={
              saveHospital
            }
            disabled={
              savingHospital
            }
          >
            {savingHospital
              ? "Saving..."
              : "Save Hospital"}
          </Button>
        </Modal.Footer>
      </Modal>


      {/* ============================================================
    ADD MEDICINE MODAL
============================================================ */}

      <Modal
        show={showMedicineModal}
        onHide={() => setShowMedicineModal(false)}
        centered
      >
        <Modal.Header closeButton className="m-3">
          <Modal.Title>
            Add New Medicine
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form.Group>
            <Form.Label>
              Medicine Name
            </Form.Label>

            <Form.Control
              type="text"
              placeholder="Enter medicine name"
              value={newMedicineName}
              onChange={(e) =>
                setNewMedicineName(e.target.value)
              }
            />
          </Form.Group>
        </Modal.Body>

        <Modal.Footer className="m-3">
          <Button
            variant="secondary"
            onClick={() =>
              setShowMedicineModal(false)
            }
            disabled={savingMedicine}
          >
            Cancel
          </Button>

          <Button
            variant="primary"
            onClick={saveMedicine}
            disabled={savingMedicine}
          >
            {savingMedicine
              ? "Saving..."
              : "Save Medicine"}
          </Button>
        </Modal.Footer>
      </Modal>
    </PageLayout >
  );
}